import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next';
import Prev from '../../../../static/images/icons/Prev';
var carousel = {
  arrowBgColor: colors.rust,
  arrowHoverBgColor: colors.deepRed,
  arrowForeColor: colors.white,
  arrowPrevMarginRightVarA: '4px',
  arrowNextMarginLeftVarA: '4px',
  highlightColor: colors.graphite,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.duskBlue,
  paginationBorderColor: colors.duskBlue,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.rust,
  heroPaginationInactiveColorVariationC: colors.rust,
  heroPaginationActiveColor: colors.rust,
  heroPaginationBorderColor: colors.deepRed,
  bgColor: colors.whiteish,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;